import React from 'react';
import { Image } from 'react-konva';
import DisableImg from 'components/main/images/DisabledImaging.png';
const DisableImageDrop = (props) => {
  const drawImage = () => {
    const imageObj = new window.Image();
    imageObj.src = DisableImg;
    const { loc } = props;
    return (
      <Image
        id='disableimagedrop-img'
        x={loc.x + props.index * props.iconwidth}
        y={loc.y + loc.h - props.iconheight}
        image={imageObj}
        width={props.iconwidth}
        height={props.iconheight}
        opacity={0.4}
      />
    );
  };

  return drawImage();
};
export default DisableImageDrop;
